module.exports = __webpack_public_path__ + "img/logo.33a0db8d.png";